module.exports = __webpack_public_path__ + "img/sharebutton.bf731574.svg";